import { initSessionGuard } from './dcms-session-guard.js';

(function() {
  // Check whether we are in the top-level window, not in an iframe
  if (window.top !== window.self) {
    return;
  }

  const guard = initSessionGuard();

  // Function that refreshes the session. The response is the classic heartbeat
  // script (`console.log('[sessionRefresh]: ping logged|not-logged…')`), read as
  // text: its status drives the session guard — the sign-in overlay over the page
  // when the session has ended. Read with fetch instead of a <script> tag, so the
  // status reaches no global another site could hook by including the script.
  function DCMS2RefreshSession() {
    fetch('/DCMS2/sessionRefresh.php', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/javascript' },
    })
      .then(function(response) {
        return response.ok ? response.text() : '';
      })
      .then(function(body) {
        const match = /ping (not-logged|logged)/.exec(body || '');
        if (match && guard) {
          guard.heartbeat(match[1]);
        }
      })
      .catch(function() {
        // Network trouble — the next tick tries again.
      });
  }

  // Refresh the session immediately after the page loads
  DCMS2RefreshSession();

  // Set up an interval to refresh the session every 30 seconds
  setInterval(DCMS2RefreshSession, 30000);
})();
